export default __webpack_public_path__ + "static/media/ImportExample.699da5ad.csv";